import { object, string, number, date } from "yup";
export const paymentValidationScheme = object({
 
  cardNumber: string().required("Kart numarası zorunludur")
    .length(19, "Kart numarası 16 karakterli olmalıdır") ,
    month: number().required("Son kullanım Tarihi zorunludur")
    .min(1, "lütfen geçerli bir değer giriniz")
    .max(12, "lütfen geçerli bir değer giriniz"),

    expireDate: string().required("Son kullanım Tarihi zorunludur").test('expireDate', 'Son kullanım Tarihi geçersizdir', (val) => expireControl(val)),
    cvc: number().required("Cvc alanı zorunludur").test('cvc', 'Cvc 3 haneli olmalıdır', (val) => val?.toString().length == 3), 
    cardHolderName: string().required("Ad soyad zorunludur"),

 
});

function expireControl (expire){

  var expireList = expire.split("/");
  if (expireList.length > 0) {
    if (expireList.length == 1) {
      return true
    } else {
      var month = parseInt(expireList[0].trim());
      var year = parseInt(expireList[1].trim());
      if (month < 1 || month > 12) {
        return true
      } else {
        year = 2000 + year;
        var nowYear = new Date().getFullYear();
        if (year < nowYear) {
          return true
        }
      }
    }
  } else {
    return true
  }
  return false;
}


/*
  cardNumber : "",
        month : 0,
        year:0,
        cvc:"",
        nameSurname :"" 
*/